// Authentication guard — "are you logged in?". Authorization ("do you
// have the role?") is RequireAccess.

import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "@noc/ui";
import { useAuth } from "./AuthContext";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (status === "anon") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
